<template>
    <ul class="user_step">
        <li 
            v-for="(step, idx) in userStep" 
            :key="idx"
            :class="step.class"
        >
            <div>
                <span>{{ idx + 1 }}</span>
                <p>{{ step.step }}</p>
            </div>
            <b-icon icon="chevron-double-down"></b-icon>
        </li>
    </ul>
</template>

<script>
export default {
    name:'UserStep',
    props: {
        userStep: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style>

</style>